<template>
  <div :class="extraClass ? extraClass : null">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ControlButton',
  props: {
    extraClass: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.right-corner {
  display: flex;
  justify-content: flex-end;
}
</style>
